export const pageSize = 10

export const policyRuleStates = {
  all: 'all',
  current: 'current',
  scheduled: 'scheduled',
  expired: 'expired',
}
